const getReduxStore = function getStoreFromComponentMethod(Component, domId) {
  if (Object.hasOwnProperty.call(Component, 'getStore')) {
    return Component.getStore(domId);
  }
  return null;
};

export default getReduxStore;
